import { useFloorplans } from "@/components/Sections/Floorplan";
import { useMediumImages } from "@/gallery/hooks";
import { TAB_ITEMS } from "@/components/UI/Tabs/contants";
/**
 * Define if either floorplans or images should be returned for preview gallery
 */
export const usePreviewGallery = () => {
    // For optimization purpose, we always use medium images for previews
    const mediumImages = useMediumImages() || [];
    const imagesCount = mediumImages.length;
    const { floorplansDesktopPreview, floorplansMobilePreview, floorplansCount } = useFloorplans();
    const itemsCount = imagesCount > 0 ? imagesCount : floorplansCount;
    const desktopPreviewItems = imagesCount > 0 ? mediumImages : floorplansDesktopPreview;
    const mobilePreviewItems = imagesCount > 0 ? mediumImages : floorplansMobilePreview;
    const activeItemType = imagesCount > 0 ? TAB_ITEMS.IMAGES : TAB_ITEMS.FLOORPLANS;
    const displayImgCTA = imagesCount >= 3;
    const displayFloorplanCTA = floorplansCount > 0;
    return {
        itemsCount,
        desktopPreviewItems,
        mobilePreviewItems,
        displayFloorplanCTA,
        displayImgCTA,
        activeItemType,
    };
};
